/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OfferContactResource { 
    id: number;
    type: string;
    changedAt: string;
    category: string;
    client: string;
    state: string;
    stateText: string;
    location: string;
    price: string;
    priority: string;
    source: string;
    insertedAt: string;
    note: string;
    phone: string;
    email: string;
}

